"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaCodeSelectorCms = void 0;
var AreaCodeSelectorCms = /** @class */ (function () {
    function AreaCodeSelectorCms() {
        this.continueCTALabel = 'Continue';
        this.newAreaCodeDescrLabel = 'Enter your preferred area code. You can also search for area codes by ZIP Code.';
        this.newAreaCodeInputBoxPlaceHolder = '3-digit area code or 5-digit ZIP Code';
        this.newAreaCodeTitleLabel = 'Enter a new area code';
        this.invalidZipCodeErrTxt = 'Enter a valid area code or ZIP';
        this.callUsHelpLabel = 'Please call us at <strong>888.333.6651</strong>, so we can help with your order.';
    }
    return AreaCodeSelectorCms;
}());
exports.AreaCodeSelectorCms = AreaCodeSelectorCms;
//# sourceMappingURL=AreaCodeSelector.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeviceOptionsPanel/DeviceCard/ExpandedFormOptions/AssignForm/AreaCodeSelector/AreaCodeSelector.cms.js
// module id = 951
// module chunks = 8